import apis from '@/api/black'

const listConfig = [
  // 类型（1:承运商,2:司机,3:车辆）
  {
    title: '类型', key: 'type', showData: {
      '1': '承运商',
      '2': '司机',
      '3': '车辆',
    }
  },
  { title: '车牌号', key: 'carNo' },
  { title: '承运商', key: 'supplierName' },
  { title: '司机', key: 'driverName' },
  { title: '司机电话', key: 'driverTel' },
  { title: '拉黑原因', key: 'remark' },
  { title: '申请人', key: 'adminName' }
]

const btnConfig = [
  { bg: '#EA5B24', title: '删 除', key: 'delete', role: 'Del' }
]

export default function config() {
  const searchConfig = [
    { title: '姓名', value: '', key: 'name', type: 'input' },
    { title: '电话', value: '', key: 'tel', type: 'input' },
    { title: '车牌号', value: '', key: 'carNo', type: 'input' }
  ]
  return {
    listConfig,
    btnConfig,
    searchConfig,
    apis
  }
}
